import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useUsersStore } from '../store/usersStore'
import { deleteUser } from '../utils/deleteUser'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteUserMutation = (onSuccess?: () => void) => {
  const remove = useUsersStore((state) => state.remove)

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: ({ message, id }) => {
      remove(id)
      toast.success(message || 'User deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting user.')
    },
  })
}
